// CRM | CS — entry do app próprio (crm.html → cs./dev-cs./qa-cs.atlanglobal.com).
//
// DELIBERADAMENTE SEM Vuetify, i18n, Maska, ApexCharts, VueTablerIcons,
// PerfectScrollbar e scss/style.scss: o CRM é 100% design system Corporate
// Console (crm.css). O que É compartilhado com o Hub vem por import de '@/'
// (axios, authStore, tenantStore, userRouteAccess, componentes ds).
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { bootstrapCrmBranding } from './branding';
import '@/assets/ds/crm.css';

// Mesmos dois handlers globais do Hub (main.ts) — sem eles um erro de chunk
// pós-deploy viraria tela branca silenciosa.
window.addEventListener('error', (event) => {
  // eslint-disable-next-line no-console
  console.error('[CRM] erro global:', event.error ?? event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  // eslint-disable-next-line no-console
  console.error('[CRM] promise rejeitada:', event.reason);
});

(async () => {
  const app = createApp(App);
  app.use(createPinia());
  app.use(router);
  // Branding ANTES do mount (padrão do Hub): evita flash da marca errada.
  // Race de 4s + fallback neutro dentro do próprio bootstrap.
  await bootstrapCrmBranding();
  app.mount('#app');
})();
